import { InputAdornment } from "@material-ui/core";

export const DOLLAR_PREFIX = { startAdornment: <InputAdornment position="start">$</InputAdornment> }

export const PERCENT_SUFFIX = { endAdornment: <InputAdornment position="end">%</InputAdornment> }